// Chip strip rendering the active search filters on the Sankey page.
//
// Each chip = one entity from the search index. Clicking the × removes the
// chip. "Clear all" wipes the filter set in one go.

import styles from './FilterChips.module.css';
import { KIND_LABELS, type SearchEntity } from './searchIndex';

interface FilterChipsProps {
  chips: readonly SearchEntity[];
  onRemove: (entity: SearchEntity) => void;
  onClear: () => void;
}

function chipKey(e: SearchEntity): string {
  return `${e.kind}::${e.value}`;
}

export function FilterChips({ chips, onRemove, onClear }: FilterChipsProps) {
  if (chips.length === 0) return null;
  return (
    <div className={styles.row} role="list" aria-label="Active filters">
      {chips.map((c) => (
        <span
          key={chipKey(c)}
          className={`${styles.chip} ${styles[`kind_${c.kind}`] ?? ''}`}
          role="listitem"
        >
          <span className={styles.kind}>{KIND_LABELS[c.kind]}</span>
          <span className={styles.label}>{c.label}</span>
          <button
            type="button"
            className={styles.close}
            aria-label={`Remove ${c.label}`}
            onClick={() => onRemove(c)}
          >
            ×
          </button>
        </span>
      ))}
      {chips.length > 1 && (
        <button type="button" className={styles.clearAll} onClick={onClear}>
          Clear all
        </button>
      )}
    </div>
  );
}
